import { MaskedLines, Reveal } from "@/components/aklive/motion";

const NEXTS = ["A launch.", "A pitch.", "A new market.", "A stronger brand.", "A better customer experience."];

export const Positioning = () => (
  <section className="py-24 md:py-40" data-testid="positioning-section">
    <div className="container-ak">
      <h2 className="font-display text-4xl font-bold leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl">
        <MaskedLines
          lines={[
            "We don't design in isolation.",
            <span key="l2">
              We design for <span className="text-ember">what comes next.</span>
            </span>,
          ]}
        />
      </h2>
      <Reveal delay={0.25} className="mt-10 md:mt-14">
        <p className="flex flex-wrap items-baseline gap-x-3 gap-y-2 font-display text-lg font-bold tracking-tight text-ink md:text-2xl">
          {NEXTS.map((n, i) => (
            <span key={n} className="flex items-baseline gap-x-3">
              {i > 0 && (
                <span aria-hidden="true" className="text-line">
                  /
                </span>
              )}
              <span>{n}</span>
            </span>
          ))}
        </p>
      </Reveal>
    </div>
  </section>
);
